<template>
  <el-popconfirm confirm-button-text='OK' cancel-button-text='No, Thanks' icon="el-icon-info" icon-color="red"
    :title="title" @confirm="onClick()">
    <el-button :size="size" :type="type" slot="reference" class="" :class="klass">{{ label }} <i
        :class="icon"></i></el-button>
  </el-popconfirm>
</template>
<script>

export default {
  props: {
    size: {
      type: String,
      description: 'Heading Title',
      default: 'mini'
    },
    label: {
      type: String,
      description: 'Heading Title',
      default: null
    },
    klass: {
      type: String,
      description: 'class name',
      default: null
    },
    type: {
      type: String,
      description: 'type',
      default: null
    },
    icon: {
      type: String,
      description: 'example fa fa-trash',
      default: null
    },
    title: {
      type: String,
      description: 'example fa fa-trash',
      default: "Are you sure about this?"
    }
  },
  data() {
    return {

    };
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    }
  }
};
</script>

<style scoped>
.error-text {
  display: block;
}
</style>